import React from 'react';
const ExpandSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        id="Vector"
        d="M10.5 2.11111H3.27778C2.3573 2.11111 1.61111 2.8573 1.61111 3.77778V18.2222C1.61111 19.1427 2.3573 19.8889 3.27778 19.8889H10.5V2.11111ZM11.6111 2.11111V19.8889H17.7222C18.6427 19.8889 19.3889 19.1427 19.3889 18.2222V3.77778C19.3889 2.8573 18.6427 2.11111 17.7222 2.11111H11.6111ZM0.5 3.77778C0.5 2.24365 1.74365 1 3.27778 1H17.7222C19.2563 1 20.5 2.24365 20.5 3.77778V18.2222C20.5 19.7563 19.2563 21 17.7222 21H3.27778C1.74365 21 0.5 19.7563 0.5 18.2222V3.77778Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default ExpandSVG;
